export default "__VITE_ASSET__BeXvGbnV__"